var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "has-bottom" },
    [
      _c(
        "div",
        { staticClass: "page-main" },
        [
          _c("el-row", { staticClass: "step-row" }, [
            _c(
              "div",
              { staticClass: "spaceAround" },
              _vm._l(_vm.stepList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "auth-step",
                    class: {
                      "is-active": _vm.active === index,
                    },
                    style: "width:" + _vm.spanCount + "%",
                    attrs: { span: _vm.spanCount },
                    on: {
                      click: function ($event) {
                        return _vm.changeStep(index)
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(index + 1) + ". " + _vm._s(item.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "auth-step-before" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "auth-step-after" }),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "keep-alive",
            [
              _c(_vm.stepList[_vm.active].comp, {
                ref: "initComp",
                tag: "component",
                attrs: { area: _vm.pageData.region },
                on: {
                  changeAsset: _vm.changeAsset,
                  changeRegion: _vm.changeRegion,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "page-bottom",
        [
          [
            _c(
              "div",
              { staticClass: "page-btns" },
              [
                _c("loading-btn", {
                  attrs: {
                    type: "primary",
                    label:
                      _vm.active == _vm.stepList.length - 1 ? "Submit" : "Next",
                  },
                  on: { clickHandle: _vm.next },
                }),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c("successDialog", {
        ref: "successDialog",
        on: { close: _vm.successClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }